<template>
  <BorderedTeam
    :src="team.picture?.pictureUrl"
    :teamName="team.name"
    :hideAvatar="team.hideAvatar"
    :class="{ 'is-muted': teamIsDeleted }"
    :isFull="isFull"
  />
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"
import { Getter } from "s-vuex-class"

import Avatar from "@/components/Avatar/index.vue"
import BorderedTeam from "@/components/BorderedTeam/BorderedTeam.vue"

import { Team } from "@/models"
import { Getters } from "@/store"

const components = {
  BorderedTeam,
  Avatar
}

@Options({
  name: "BorderedTeamByProject",
  components
})
export default class extends Vue {
  @Prop({ required: true }) readonly team: Team
  @Prop({ default: true }) readonly isFull: boolean

  @Getter(Getters.GET_SESSION_PROJECT_ID) readonly sessionProjectId: string

  get teamIsDeleted() {
    return Team.checkDeletedFromProject(this.team, this.sessionProjectId)
  }
}
</script>
